/**
 * Previous Year Question Papers Data
 *
 * Structure of each entry:
 * {
 *   id        : number         – unique identifier
 *   exam      : string         – "JEE Main" | "JEE Advanced"
 *   year      : number         – e.g. 2024
 *   session   : string         – "Session 1" | "Session 2"
 *   date      : string         – human-readable date, e.g. "January 27, 2024"
 *   shift     : string         – "Shift 1" | "Shift 2"
 *   paperUrl  : string | null  – Google Drive link to the question paper PDF
 *   answerUrl : string | null  – Google Drive link to the answer key PDF
 * }
 *
 * HOW TO ADD A NEW PAPER:
 * 1. Copy one of the objects below.
 * 2. Increment `id` by 1.
 * 3. Fill in the correct year, session, date, shift.
 * 4. Paste the Google Drive share link into `paperUrl` and `answerUrl`.
 *    (Use the "Share → Anyone with the link" URL from Google Drive.)
 * 5. Set `paperUrl` or `answerUrl` to null if the PDF is not yet available.
 */

export const pyqData = [
    {
        id: 1,
        exam: "JEE Main",
        year: 2025,
        session: "Session 1",
        date: "January 23, 2025",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1XSCNChU8bJXNiabY-s4BM-eWX5ZSc5ft/view?usp=drive_link",
    },
    {
        id: 2,
        exam: "JEE Main",
        year: 2025,
        session: "Session 1",
        date: "January 24, 2025",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1uh3W7hLqnkN101febDyE5-PfXrBSWEU3/view?usp=drive_link",
    },
    {
        id: 3,
        exam: "JEE Main",
        year: 2025,
        session: "Session 2",
        date: "April 2, 2025",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1Imc_XUbPN7dOzXfZBdPhBKq2EUtjVsBm/view?usp=drive_link",
    },
    {
        id: 4,
        exam: "JEE Main",
        year: 2025,
        session: "Session 2",
        date: "April 2, 2025",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1F7IrTJSh0vvAQANdnCQWHxyOCuLvg8ah/view?usp=drive_link",
    },
    {
        id: 5,
        exam: "JEE Main",
        year: 2025,
        session: "Session 2",
        date: "April 3, 2025",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1uzME0Zahbhtbp9W7NMlHWS7Z-r-LlSGI/view?usp=drive_link",
    },
    {
        id: 6,
        exam: "JEE Main",
        year: 2025,
        session: "Session 2",
        date: "April 3, 2025",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1GSGdydWhTUKI44tbqIOfp75AhKOey-fr/view?usp=drive_link",
    },
    {
        id: 7,
        exam: "JEE Main",
        year: 2025,
        session: "Session 2",
        date: "April 4, 2025",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1RY19u_HIsVi-4CDSD5iuMcu2DI5kSnfC/view?usp=drive_link",
    },
    {
        id: 8,
        exam: "JEE Main",
        year: 2025,
        session: "Session 2",
        date: "April 4, 2025",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1Z-4Q18UQX_yZi0WbOtoI_vmhzZIlbZIZ/view?usp=drive_link",
    },
    {
        id: 9,
        exam: "JEE Main",
        year: 2025,
        session: "Session 2",
        date: "April 7, 2025",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1P1tWfLpcnHLGp4rcgtMe1s8d9xVbmTVa/view?usp=drive_link",
    },
    {
        id: 10,
        exam: "JEE Main",
        year: 2025,
        session: "Session 2",
        date: "April 7, 2025",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1JSKNDvn394Og05WiucNrdg5PtI6xj10F/view?usp=drive_link",
    },
    {
        id: 11,
        exam: "JEE Main",
        year: 2025,
        session: "Session 2",
        date: "April 8, 2025",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1uQxchO_tB6cTLMgPC18eEmBw3HZ4-EG_/view?usp=drive_link",
    },
    {
        id: 12,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 21, 2026",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1Xmaig3R2hyDjTcDBr3C14ZkrRVV2al3h/view?usp=drive_link",
    },
    {
        id: 13,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 21, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1L4-pyNo294092b7ubIC1CbRHuEg-wvE5/view?usp=drive_link",
    },
    {
        id: 14,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 22, 2026",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1F_GtSWOfnKnuNa_wta1wMTESGM0EB0Lk/view?usp=drive_link",
    },
    {
        id: 15,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 22, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1Gc8Ej1vJFxtWtQ2lyTa_SiKBfWPe7HiT/view?usp=drive_link",
    },
    {
        id: 16,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 23, 2026",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1DQJr7M92dwCLMsolPgFwgYZDTnQAYnFB/view?usp=drive_link",
    },
    {
        id: 17,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 23, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1Bq7A8apN6fgi_HhMre4qT-bCdGoAVG4_/view?usp=drive_link",
    },
    {
        id: 18,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 24, 2026",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/143OTeKO3TyVDzPUgDu283vMZsuKS4qk8/view?usp=drive_link",
    },
    {
        id: 19,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 24, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1IzXaooVl66GBC0u_l3XwQntlryG5QPqW/view?usp=drive_link",
    },
    {
        id: 20,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 28, 2026",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1XL530uEIyKq3iA152WXp8zPdVo8HzNpQ/view?usp=drive_link",
    },
    {
        id: 21,
        exam: "JEE Main",
        year: 2026,
        session: "Session 1",
        date: "January 28, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1whiUoN3dUb2HguDokidTjnWew4hVwLRv/view?usp=drive_link",
    },
    {
        id: 22,
        exam: "JEE Main",
        year: 2024,
        session: "Session 1",
        date: "February 1, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1DDtKOPZxBuAeeaQCAKItjbEzVCc1BBhW/view?usp=drive_link",
    },
    {
        id: 23,
        exam: "JEE Main",
        year: 2024,
        session: "Session 1",
        date: "February 1, 2024",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1ns2TN8uW9GFMdrVV8O_dB9AbLFWl0iKq/view?usp=drive_link",
    },
    {
        id: 24,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 4, 2024",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1pfNTUKklPR-NBkcc5MoePx9zm-fvBzw3/view?usp=drive_link",
    },
    {
        id: 25,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 5, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1OO-qQFD7Zi6U0WCJN7a9Pfl3UgGOOHjB/view?usp=drive_link",
    },
    {
        id: 26,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 6, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1KtroMZeINSL09QOmxgkYbd7oKQG2cMSq/view?usp=drive_link",
    },
    {
        id: 27,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 6, 2024",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1bbxLYf8NZ1iaGGqX-2ERbJKG_V4XK8ZG/view?usp=drive_link",
    },
    {
        id: 28,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 8, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1ITDnhBVKZSvIPFVMwyV27h7JCsef4PXU/view?usp=drive_link",
    },
    {
        id: 29,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 8, 2024",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1yGDWNcXPxIEUGoGEDlgDfwNG8q2FWZw4/view?usp=drive_link",
    },
    {
        id: 30,
        exam: "JEE Main",
        year: 2024,
        session: "Session 1",
        date: "January 27, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1AQbis6XEppWBNUR3MgTqXNmfeTKekxAL/view?usp=drive_link",
    },
    {
        id: 31,
        exam: "JEE Main",
        year: 2024,
        session: "Session 1",
        date: "January 27, 2024",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1SpyJss2netJojXml_PJCU3blFwLYFwho/view?usp=drive_link",
    },
    {
        id: 32,
        exam: "JEE Main",
        year: 2024,
        session: "Session 1",
        date: "January 29, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/19-8R5qXd5kIXyffqgVw5xOisjoYTpZZA/view?usp=drive_link",
    },
    {
        id: 33,
        exam: "JEE Main",
        year: 2024,
        session: "Session 1",
        date: "January 29, 2024",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1zj4lyPA-8z5bBdHpE9-UQP-2Z3gOrUaB/view?usp=drive_link",
    },
    {
        id: 34,
        exam: "JEE Main",
        year: 2024,
        session: "Session 1",
        date: "January 31, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1hx00jSplQWM3zoe4jm-ROZ80fh-qOb8N/view?usp=drive_link",
    },
    {
        id: 35,
        exam: "JEE Main",
        year: 2024,
        session: "Session 1",
        date: "January 30, 2024",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1DGQqtut6iY0XKbaZdd4uHzcI7pRG5MDv/view?usp=drive_link",
    },
    {
        id: 36,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 4, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1z_O8pnwddLPZlNz66EtwKWkeYVe99ckm/view?usp=drive_link",
    },
    {
        id: 37,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 5, 2024",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/18F9gTQcVHW3QTnPtQVJ8D0YpfINBnTUp/view?usp=drive_link",
    },
    {
        id: 38,
        exam: "JEE Main",
        year: 2024,
        session: "Session 1",
        date: "January 30, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1j9H5Q0YtkjDexCffR-oP80dmzwH7tNsu/view?usp=drive_link",
    },
    {
        id: 39,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 9, 2024",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1mJVKRqid68hFRa76GjZdLkUdDwBwckvY/view?usp=drive_link",
    },
    {
        id: 40,
        exam: "JEE Main",
        year: 2024,
        session: "Session 2",
        date: "April 9, 2024",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/11cdR5Bv4M1XqwkpnlRPcCXxU9NXQz05A/view?usp=drive_link",
    },
    {
        id: 41,
        exam: "JEE Main",
        year: 2026,
        session: "Session 2",
        date: "April 2, 2026",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1gFdX1prkNg-c3eUYaV7NJMwzfhRkZ0Lw/view?usp=drive_link",
    },
    {
        id: 42,
        exam: "JEE Main",
        year: 2026,
        session: "Session 2",
        date: "April 5, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/121axXL9xp3OKCz5wnDQRcF-H5LgvCwk_/view?usp=drive_link",
    },
    {
        id: 43,
        exam: "JEE Main",
        year: 2026,
        session: "Session 2",
        date: "April 6, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/18-mrC4q_SL06CIkgduudAReCoVHeCRLU/view?usp=drive_link",
    },
    {
        id: 44,
        exam: "JEE Main",
        year: 2026,
        session: "Session 2",
        date: "April 2, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1N1mO1MtoKK-BqHZ_58MNZywkb7W2u3th/view?usp=drive_link",
    },
    {
        id: 45,
        exam: "JEE Main",
        year: 2026,
        session: "Session 2",
        date: "April 4, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1RFNHmAmorg8ux0LurcYKym8Wox4z5yAp/view?usp=drive_link",
    },
    {
        id: 46,
        exam: "JEE Main",
        year: 2026,
        session: "Session 2",
        date: "April 6, 2026",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1TgJ2-ve1enEwwz2SKyxTHsOqNp64YPFM/view?usp=drive_link",
    },
    {
        id: 47,
        exam: "JEE Main",
        year: 2026,
        session: "Session 2",
        date: "April 8, 2026",
        shift: "Shift 2",
        paperUrl: "https://drive.google.com/file/d/1oEKGvDaUXBCHV1VYJxUfqAFloSWwIlF5/view?usp=drive_link",
    },
    {
        id: 48,
        exam: "JEE Main",
        year: 2026,
        session: "Session 2",
        date: "April 4, 2026",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1pYXFi4uaqShJHzlOhB_GCFNeVyEn82Jc/view?usp=drive_link",
    },
    {
        id: 49,
        exam: "JEE Main",
        year: 2026,
        session: "Session 2",
        date: "April 5, 2026",
        shift: "Shift 1",
        paperUrl: "https://drive.google.com/file/d/1tpSnbai1iV1bm08LT1zTfwwvDA3czFk1/view?usp=drive_link",
    },
];
